import React from "react";

export interface IDropdownStateProps {
  open?: boolean;
  wrapperRef?: React.Ref<any>;
  onTargetClick?: () => void;
  closeOnClickAnywhere?: boolean;
}

export interface IDropdownStateState {
  open: boolean;
}

export const withDropdownState = <P extends IDropdownStateProps>(WrappedComponent: React.ComponentType<P>) => {
  type Props = Omit<P & IDropdownStateProps, "wrapperRef" | "onTargetClick">;

  return class DropdownUsage extends React.PureComponent<Props, IDropdownStateState> {
    static defaultProps: Partial<IDropdownStateProps> = {
      closeOnClickAnywhere: true,
    };

    readonly state: IDropdownStateState = {
      open: !!this.props.open,
    };

    wrapperRef = React.createRef();

    componentDidMount() {
      if (this.props.closeOnClickAnywhere) {
        document.addEventListener("click", this.handleClickAnywhere);
      }
    }

    componentWillUnmount() {
      if (this.props.closeOnClickAnywhere) {
        document.removeEventListener("click", this.handleClickAnywhere);
      }
    }

    openDropdown() {
      this.setState({ open: true });
    }

    closeDropdown() {
      this.setState({ open: false });
    }

    handleClickAnywhere = ({ target }: Event) => {
      const wrapper = this.wrapperRef.current;

      if (wrapper && !(wrapper as any).contains(target as Node)) {
        this.closeDropdown();
      }
    };

    handleClick = () => {
      this.state.open ? this.closeDropdown() : this.openDropdown();
    };

    render() {
      return (
        <WrappedComponent
          {...(this.props as any)}
          open={this.state.open}
          onTargetClick={this.handleClick}
          wrapperRef={this.wrapperRef}
        />
      );
    }
  };
};
